"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnimationController = void 0;

var react_1 = require("react");

function useAnimationController() {
  var ref = (0, react_1.useRef)(null);
  var play = (0, react_1.useCallback)(function () {
    var _a;

    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.play();
  }, [ref]);
  var pause = (0, react_1.useCallback)(function () {
    var _a;

    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.pause();
  }, [ref]);
  var reverse = (0, react_1.useCallback)(function () {
    var _a;

    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.reverse();
  }, [ref]);
  var cancel = (0, react_1.useCallback)(function () {
    var _a;

    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.cancel();
  }, [ref]);
  var finish = (0, react_1.useCallback)(function () {
    var _a;

    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.finish();
  }, [ref]);
  var seek = (0, react_1.useCallback)(function (value) {
    var _a;

    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.seek(value);
  }, [ref]);
  var animate = (0, react_1.useCallback)(function (args, context) {
    var _a;

    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.animate(args, context);
  }, [ref]);
  var getId = (0, react_1.useCallback)(function () {
    var _a;

    return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getId();
  }, [ref]);
  var getPlayState = (0, react_1.useCallback)(function () {
    var _a;

    return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getPlayState();
  }, [ref]);
  var getContext = (0, react_1.useCallback)(function () {
    var _a;

    return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getContext();
  }, [ref]);
  var updatePlaybackRate = (0, react_1.useCallback)(function (rate) {
    var _a;

    return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.updatePlaybackRate(rate);
  }, [ref]);
  return {
    ref: ref,
    play: play,
    pause: pause,
    reverse: reverse,
    cancel: cancel,
    finish: finish,
    seek: seek,
    animate: animate,
    getId: getId,
    getPlayState: getPlayState,
    getContext: getContext,
    updatePlaybackRate: updatePlaybackRate
  };
}

exports.useAnimationController = useAnimationController;